import axios from "axios";

const KEY = "AIzaSyBq1Ctud7bp7IPdde1vcufgN58xBKDP75A";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    type: "video",
    maxResults: 5,
    key: KEY,
  },
});
